import React from "react";
import UsersTable from "../features/users/usersTable";

const Users = () => {
	return (
		<div className="row">
			<div className="col-12">
				<div className="card">
					<div className="card-body dashboard-card-body">
						<h1>Users</h1>
					</div>
					<UsersTable />
				</div>
			</div>
		</div>
	);
};

export default Users;
